<style src="./StagesHeader.scss" lang="scss"></style>
<template>
  <li class="stages-header">
    <ul class="stages-header-container">
      <li class="event-column"></li>
      <li
        class="stage"
        v-for="(stage, stageIdx) in stages"
        :key="stageIdx"
        @click="showStageOptionsPopup(stageIdx)"
        >

        <div
          class="status-container">
          <div
            v-show="stageFilter[stage._id] && stageFilter[stage._id].includes('open')"
            class="status status__open"></div>
          <div
            v-show="stageFilter[stage._id] && stageFilter[stage._id].includes('start')"
            class="status status__start"></div>
          <div
            v-show="stageFilter[stage._id] && stageFilter[stage._id].includes('finish')"
            class="status status__finish"></div>
          <div
            v-show="stageFilter[stage._id] && stageFilter[stage._id].includes('unopen')"
            class="status status__unopen"></div>
        </div>

        <div
          class="particularfilter">
          <span
            class="label"
            v-if="particularStatus && stage._id === '5e0ee5a7db184e7232afef9b'">{{ particularStatus }}</span>
          <span
            class="label"
            v-if="particularMetaStatus && particularMetaStatus.returnDate && stage._id === '5e0ee5a7db184e7232afef9b'">{{ particularMetaStatus.returnDate | DateBR }}</span>
          <span
            class="label"
            v-if="particularMetaStatus && !(particularMetaStatus && particularMetaStatus.returnDate) && stage._id === '5e0ee5a7db184e7232afef9b'">{{ particularMetaStatus.metaStatus }}</span>
        </div>

        <div class="title-container">
          <span class="title">
            {{ stage.name }}
          </span>
        </div>
        
        <div
          class="popup-stage-options"
          v-if="stageOptionsPopupIsVisible[stageIdx].isVisible"
          v-click-outside="hideStageOptionsPopup">
          <ul class="popup-stage-list">
            <li class="popup-stage-item">
              <ul class="stage-filters-list">
                <li 
                  class="stage-filters-item open"
                  :class="{ 'active-open': stageFilter[stage._id] && stageFilter[stage._id].includes('open') }"
                  @click="filterBy(statusOpen, stage._id)">
                </li>
                
                <li
                  class="stage-filters-item start"
                  :class="{ 'active-start': stageFilter[stage._id] && stageFilter[stage._id].includes('start') }"
                  @click="filterBy(statusStart, stage._id)">
                </li>
                
                <li 
                  class="stage-filters-item finish"
                  :class="{ 'active-finish': stageFilter[stage._id] && stageFilter[stage._id].includes('finish') }"
                  @click="filterBy(statusFinish, stage._id)">
                </li>
                
                <li
                  class="stage-filters-item unopened"
                  :class="{ 'active-unopen': stageFilter[stage._id] && stageFilter[stage._id].includes('unopen') }"
                  @click="filterBy(statusUnopened, stage._id)">
                </li>
              </ul>
            </li>

            <li>
              <popup-options-emandamento
                v-show="stage._id === '5e0ee5a7db184e7232afef9b'"
                :popup-filters="popupFilter"
                @select="selectEmandamento" />
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
import PopupOptionsEmandamento from './components/popup-options-emandamento/PopOptionsEmandamento'
import { mapGetters } from 'vuex'
import { DateBR } from '@/components/primitives/helpers/filters'

const STATUS_OPEN = 'open'
const STATUS_START = 'start'
const STATUS_FINISH = 'finish'
const STATUS_UNOPENED = 'unopened'

export default {
  name: 'StagesHeader',
  components: {
    PopupOptionsEmandamento
  },
  props: {
    stages: {
      default: {}
    }
  },
  data () {
    return {
      statusOpen: STATUS_OPEN,
      statusStart: STATUS_START,
      statusFinish: STATUS_FINISH,
      statusUnopened: STATUS_UNOPENED,
      stageFilter: {},
      stageOptionsPopupIsVisible: [],
      popupFilter: {}
    }
  },
  filters: {
    DateBR
  },
  computed: {
    ...mapGetters({
      particularStatus: 'Board/GET_EMANDAMENTO_STATUS',
      particularMetaStatus: 'Board/GET_EMANDAMENTO_META_STATUS'
    })
  },
  watch: {
    stages: {
      handler (v) {
        this.setPopupMenu(v)
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    const stageFilter = this.$store.getters['Board/FILTERS']
    this.stageFilter = stageFilter.stage
  },
  methods: {
    filterBy (status, stageId) {
      const stageFilter = { ...this.stageFilter }

      if (!stageFilter[stageId]) stageFilter[stageId] = []

      const idxOf = stageFilter[stageId].indexOf(status)
      if (idxOf > -1) {
        stageFilter[stageId].splice(idxOf, 1)
        if (stageFilter[stageId].length === 0) {
          delete stageFilter[stageId]
        }
      } else {
        stageFilter[stageId].push(status)
      }

      if (Object.keys(stageFilter).length > 1) {
        delete stageFilter[Object.keys(stageFilter)[0]]
      }

      this.stageFilter = stageFilter
      this.$store.commit('Board/SET_FILTER_STAGE', stageFilter)
    },
    showStageOptionsPopup (pListIdx) {
      this.hideAllStagePopups()
      this.stageOptionsPopupIsVisible[pListIdx].isVisible = true
    },
    hideStageOptionsPopup () {
      this.hideAllStagePopups()
    },
    hideAllStagePopups () {
      const allOff = this.stageOptionsPopupIsVisible.map(item => ({ ...item, isVisible: false }))
      this.stageOptionsPopupIsVisible = allOff
    },
    setPopupMenu (v) {
      const stagePopup = v.map(item => {
        return {
          isVisible: false,
          isExpanded: true
        }
      })
      this.stageOptionsPopupIsVisible = stagePopup
    },
    selectEmandamento (emandamento) {
      this.popupFilter = emandamento
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/board/components/stages-header/StagesHeader.vue